import React, { Component } from 'react';
import Translate from 'react-translate-component';
import { pathOr } from 'ramda';

import XMLFields from './XMLFields';

const markeingContact = [
    { name: 'MRKTCALL.DATE', label: 'DATE', type: 'DatePicker' },
    { name: 'MRKTCALL.TYPE', label: 'TYPE'},
    { name: 'MRKTCALL.TARGET', label: 'TARGET' },
];

const client = [
    { name: 'MRKTCALL.ORGNAME', label: 'ORGNAME' },
    { name: 'MRKTCALL.ORGKATEGOR', label: 'ORGKATEGOR', type: 'SelectLoad', options: { loadName: 'mrktclienttype', namePath: 'value', valuePath: 'value' } },
    { name: 'MRKTCALL.INFABOUT', label: 'INFABOUT' },
];

const selfParticipants = [
    { name: 'MRKTCALL.SOTRNAME', label: 'SOTRNAME' },
    { name: 'MRKTCALL.ADDANCORSOTR', label: 'ADDANCORSOTR' },
];

const clientParticipants = [
    { name: 'MRKTCALL.PPLNAME', label: 'PPLNAME' },
    { name: 'MRKTCALL.PPLDOLG', label: 'PPLDOLG' },
    { name: 'MRKTCALL.ADDZAKSOTR', label: 'ADDZAKSOTR' }
];

const resultFields = [
    { name: 'MRKTCALL.ABOUTSPEAK', label: 'ABOUTSPEAK' },
    { name: 'MRKTCALL.RESULT', label: 'RESULT' },
    { name: 'MRKTCALL.NEXTDATE', label: 'NEXTDATE', type: 'DatePicker' },
    { name: 'MRKTCALL.TARGETDESCR', label: 'TARGETDESCR' },
];

class Marketing extends Component {
    componentDidMount() {
        const { event } = this.props;

        if (event && event.details) {
            const { details } = event;

            setTimeout(() => {
                this.props.form.change('result.xmlbody.MRKTCALL.DATE', details.eventDate);
                this.props.form.change('result.xmlbody.MRKTCALL.SOTRNAME', pathOr('', ['responsible', 0, 'text'], details));
                this.props.form.change('result.xmlbody.MRKTCALL.PPLNAME', pathOr('', ['contact', 0, 'text'], details));
                this.props.form.change('result.xmlbody.MRKTCALL.ORGNAME', pathOr('', ['company', 0, 'text'], details));
            }, 0);
        }
    }

    render() {
        return (
            <div>
                <Translate content='xml.OrgMrktCallData.title.marketingContact' component='h3' />
                <XMLFields fieldsXML={markeingContact} translatePrefix='OrgMrktCallData' />

                <Translate content='xml.OrgMrktCallData.title.client' component='h3' />
                <XMLFields fieldsXML={client} translatePrefix='OrgMrktCallData' />

                <Translate content='xml.OrgMrktCallData.title.selfParticipants' component='h3' />
                <XMLFields fieldsXML={selfParticipants} translatePrefix='OrgMrktCallData' />

                <Translate content='xml.OrgMrktCallData.title.clientParticipants' component='h3' />
                <XMLFields fieldsXML={clientParticipants} translatePrefix='OrgMrktCallData' />

                <XMLFields fieldsXML={resultFields} translatePrefix='OrgMrktCallData' />
            </div>
        );
    }
}

export default Marketing;
